/**
 * @property STORAGE_KEY
 * @type {Object}
 * @final
 */
export const STORAGE_KEY = {
    ATC_LAST_AIRPORT: 'atc-last-airport',
    ATC_LAST_VERSION: 'atc-last-version',
    ATC_SPEECH_ENABLED: 'atc-speech-enabled',
    FIRST_RUN_TIME: 'first-run-time',
    ZOOM_LEVEL: 'zoom-level'
};
